// extracted by mini-css-extract-plugin
export default {"sideMenuNoLink":"SidebarMenu_sideMenuNoLink__S7pYO","menuGroupTitle":"SidebarMenu_menuGroupTitle__dYzL4","menuWrapper":"SidebarMenu_menuWrapper__Y+sEC"};